/* eslint-disable regexp/no-useless-flag */
/* eslint-disable unicorn/catch-error-name */
/* eslint-disable regexp/no-useless-escape */
/* eslint-disable no-useless-escape */
/* eslint-disable regexp/prefer-w */
/* eslint-disable unicorn/no-for-loop */
/* eslint-disable unicorn/prefer-add-event-listener */
/* eslint-disable unicorn/prefer-includes */
/* eslint-disable unicorn/switch-case-braces */
/* eslint-disable unicorn/prefer-string-slice */
/* eslint-disable unicorn/no-new-array */
/* eslint-disable unicorn/no-typeof-undefined */
/* eslint-disable unicorn/no-negated-condition */
/* eslint-disable regexp/use-ignore-case */
/* eslint-disable regexp/prefer-d */
/* eslint-disable unicorn/better-regex */
/* eslint-disable unicorn/prefer-optional-catch-binding */
/* eslint-disable regexp/no-unused-capturing-group */
/* eslint-disable unicorn/prefer-string-replace-all */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/no-static-only-class */
/* eslint-disable no-bitwise */
/* eslint-disable no-multi-assign */
import DOMPurify from 'dompurify';
import camelCase from 'lodash/camelCase';
import trim from 'lodash/trim';
import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';
import upperFirst from 'lodash/upperFirst';
export class AString {
    /**
     * Capitalizes the first letter of each word, including the very first letter and removes any spaces.
     * StudlyCase is also known as PascalCase.
     * @example
     * 'foo bar' => 'FooBar'
     * 'Foo Bar' => 'FooBar'
     * 'fooBar' => 'FooBar'
     * 'FooBar' => 'FooBar'
     * '--foo-bar--' => 'FooBar'
     * '__FOO_BAR__' => 'FooBar'
     * '!--foo-¿?-bar--121-**%' => 'FooBar121'
     * 'Here i am' => 'HereIAm'
     * 'FOO BAR' => 'FooBar'
     */
    static studly(str) {
        return upperFirst(camelCase(str));
    }
    /**
     * @example The Quick *fox => the-quick--fox
     *
     * ```js
     * AString.slug('The Quick *fox') === 'the-quick--fox'
     * ```
     *
     */
    static slug(str) {
        return str
            .replace(/([a-z])([A-Z])/g, '$1-$2')
            .replace(/[\s_]+/g, '-')
            .toLowerCase();
    }
    /**
     * Uppercase the first character of each word in a string.
     *
     * @example the quick fox => The Quick Fox
     */
    static title(str) {
        return `${str}`.replace(/^(.)|\s+(.)/g, ($1) => $1.toUpperCase());
    }
    /**
     * Uppercase the first character of a string.
     *
     * @example the quick fox => The quick fox
     */
    static ucfirst(str) {
        return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    }
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
     *
     * @example 'fox'.padStart(6, 'X') => XXXfox
     */
    static padStart(str, maxLength, fillString) {
        str = `${str}`; // convert numbers to string
        return str.padStart(maxLength, fillString);
    }
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padEnd
     *
     * @example 'fox'.padEnd(6, '.') => fox...
     */
    static padEnd(str, maxLength, fillString) {
        str = `${str}`; // convert numbers to string
        return str.padEnd(maxLength, fillString);
    }
    /**
     * Uppercase the first character of each word in a string.
     *
     * @example the quick fox => The Quick Fox
     */
    static ucwords(str) {
        return str.replace(/^(.)|\s+(.)/g, ($1) => $1.toUpperCase());
    }
    /**
     * @see https://lodash.com/docs/4.17.15#trim
     * Trims the specified string by removing the provided mask from the beginning and end of the string.
     * By default will remove any spaces.
     */
    static trim(str, mask = ' ') {
        return trim(str, mask);
    }
    /**
     * @see https://lodash.com/docs/4.17.15#trimStart
     * Trims the specified string by removing the provided mask from the beginning of the string.
     * By default will remove any spaces.
     */
    static ltrim(str, mask = ' ') {
        return trimStart(str, mask);
    }
    /**
     * @see https://lodash.com/docs/4.17.15#trimEnd
     * Trims the specified string by removing the provided mask from the end of the string.
     * By default will remove any spaces.
     */
    static rtrim(str, mask = ' ') {
        return trimEnd(str, mask);
    }
    /**
     * Concatenate a string by a amount of characters
     */
    static concatenate(str, characters = 100) {
        if (str.length >= characters) {
            return `${str.slice(0, characters)}...`;
        }
        return str;
    }
    /**
     * Concatenate a string by a amount of characters
     */
    static isValidJson(str) {
        try {
            JSON.parse(str);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    /**
     * Formats a number for its string representation, seperating it's decimals and thousands.
     *
     * @example
     * AString.numberFormat(1337) => 1,337.00
     * AString.numberFormat(19910527.02, '.', ',') => 19.910.527,02
     */
    static numberFormat(number, decimals = 0, decimalSymbol = '.', thousandsSeperator = ',') {
        // Strip all characters but numerical ones.
        number = `${number}`.replace(/[^0-9+\-Ee.]/g, '');
        const n = !Number.isFinite(+number) ? 0 : +number;
        const prec = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals);
        const sep = typeof thousandsSeperator === 'undefined' ? ',' : thousandsSeperator;
        const dec = typeof decimalSymbol === 'undefined' ? '.' : decimalSymbol;
        const toFixedFix = (n, prec) => {
            const k = 10 ** prec;
            return `${Math.round(n * k) / k}`;
        };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        const parts = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
        if (parts[0].length > 3) {
            parts[0] = parts[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((parts[1] || '').length < prec) {
            parts[1] = parts[1] || '';
            parts[1] += new Array(prec - parts[1].length + 1).join('0');
        }
        return parts.join(dec);
    }
    /**
     * Generates a unique UUID that can be used accross systems.
     * This string is used as a unique identifier.
     *
     * @example AString.uuid() => b32ee4f0-7ced-466e-9f6c-7f060d072e1b
     */
    static uuid() {
        const s = [];
        const hexDigits = '0123456789abcdef';
        for (let i = 0; i < 36; i += 1) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((Number(s[19]) & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';
        const uuid = s.join('');
        return uuid;
    }
    /**
     * Validates whether the passed string is a valid UUID or not.
     *
     * @example
     * AString.isUuid('b32ee4f0-7ced-466e-9f6c-7f060d072e1b) => true
     * AString.isUuid('fake-uuid-is-not-real-test') => false
     */
    static isUuid(uuid, version) {
        // Regular expression used for basic parsing of the uuid.
        const pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        // If it's a string, it's already good. Else return
        if (Object.prototype.toString.call(uuid) !== '[object String]') {
            return false;
        }
        const parsedUuid = uuid.toLowerCase();
        // All UUIDs fit a basic schema. Match that.
        if (!pattern.test(parsedUuid)) {
            return false;
        }
        // Now extract the version...
        const extractedVersion = Number.parseInt(parsedUuid.charAt(14), 10);
        if (extractedVersion !== version) {
            return false;
        }
        switch (version) {
            // For certain versions, the checks we did up to this point are fine.
            case 1:
            case 2:
                return true;
            // For versions 3 and 4, they must specify a variant.
            case 3:
            case 4:
            case 5:
                return ['8', '9', 'a', 'b'].indexOf(parsedUuid.charAt(19)) !== -1;
            default:
                // We should only be able to reach this if the consumer explicitly
                // provided an invalid version. Prior to extractVersion we check
                // that it's 1-4 in the regex.
                throw new Error('Invalid version provided.');
        }
    }
    static decode(encodedString) {
        const entities = {
            amp: '&',
            apos: "'",
            '#x27': "'",
            '#x2F': '/',
            '#39': "'",
            '#47': '/',
            lt: '<',
            gt: '>',
            nbsp: ' ',
            quot: '"'
        };
        return encodedString.replace(/&([^;]+);/gm, (match, entity) => entities[entity] || match);
    }
    /**
     * Truncates the given string at the specified length.
     *
     * @example The quick brown fox => The quick...
     */
    static limit(str, threshold = 80, appendage = '...') {
        threshold -= appendage.length;
        if (str.length >= threshold) {
            return `${str.slice(0, threshold)}${appendage}`;
        }
        return str;
    }
    /**
     * Mainly used for Datatables to allow raw html but also clean any potential XSSSanitizes a string for use in v-html (innerHTML) bindings
     */
    static purify(str, allowHtml = true) {
        return DOMPurify.sanitize(str, { USE_PROFILES: { html: allowHtml } });
    }
    /**
     * Converts a file to a base64 encoded string.
     */
    static fromFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    }
}
/**
 * Sanatizes a file's name by stripping any special characters, making it URL and filesystem friendly.
 */
AString.sanitizeFilename = (name) => {
    // Replace special character too closest variant
    const find = [
        'À',
        'Á',
        'Â',
        'Ã',
        'Ä',
        'Å',
        'Æ',
        'Ç',
        'È',
        'É',
        'Ê',
        'Ë',
        'Ì',
        'Í',
        'Î',
        'Ï',
        'Ð',
        'Ñ',
        'Ò',
        'Ó',
        'Ô',
        'Õ',
        'Ö',
        'Ø',
        'Ù',
        'Ú',
        'Û',
        'Ü',
        'Ý',
        'ß',
        'à',
        'á',
        'â',
        'ã',
        'ä',
        'å',
        'æ',
        'ç',
        'è',
        'é',
        'ê',
        'ë',
        'ì',
        'í',
        'î',
        'ï',
        'ñ',
        'ò',
        'ó',
        'ô',
        'õ',
        'ö',
        'ø',
        'ù',
        'ú',
        'û',
        'ü',
        'ý',
        'ÿ',
        'Ā',
        'ā',
        'Ă',
        'ă',
        'Ą',
        'ą',
        'Ć',
        'ć',
        'Ĉ',
        'ĉ',
        'Ċ',
        'ċ',
        'Č',
        'č',
        'Ď',
        'ď',
        'Đ',
        'đ',
        'Ē',
        'ē',
        'Ĕ',
        'ĕ',
        'Ė',
        'ė',
        'Ę',
        'ę',
        'Ě',
        'ě',
        'Ĝ',
        'ĝ',
        'Ğ',
        'ğ',
        'Ġ',
        'ġ',
        'Ģ',
        'ģ',
        'Ĥ',
        'ĥ',
        'Ħ',
        'ħ',
        'Ĩ',
        'ĩ',
        'Ī',
        'ī',
        'Ĭ',
        'ĭ',
        'Į',
        'į',
        'İ',
        'ı',
        'Ĳ',
        'ĳ',
        'Ĵ',
        'ĵ',
        'Ķ',
        'ķ',
        'Ĺ',
        'ĺ',
        'Ļ',
        'ļ',
        'Ľ',
        'ľ',
        'Ŀ',
        'ŀ',
        'Ł',
        'ł',
        'Ń',
        'ń',
        'Ņ',
        'ņ',
        'Ň',
        'ň',
        'ŉ',
        'Ō',
        'ō',
        'Ŏ',
        'ŏ',
        'Ő',
        'ő',
        'Œ',
        'œ',
        'Ŕ',
        'ŕ',
        'Ŗ',
        'ŗ',
        'Ř',
        'ř',
        'Ś',
        'ś',
        'Ŝ',
        'ŝ',
        'Ş',
        'ş',
        'Š',
        'š',
        'Ţ',
        'ţ',
        'Ť',
        'ť',
        'Ŧ',
        'ŧ',
        'Ũ',
        'ũ',
        'Ū',
        'ū',
        'Ŭ',
        'ŭ',
        'Ů',
        'ů',
        'Ű',
        'ű',
        'Ų',
        'ų',
        'Ŵ',
        'ŵ',
        'Ŷ',
        'ŷ',
        'Ÿ',
        'Ź',
        'ź',
        'Ż',
        'ż',
        'Ž',
        'ž',
        'ſ',
        'ƒ',
        'Ơ',
        'ơ',
        'Ư',
        'ư',
        'Ǎ',
        'ǎ',
        'Ǐ',
        'ǐ',
        'Ǒ',
        'ǒ',
        'Ǔ',
        'ǔ',
        'Ǖ',
        'ǖ',
        'Ǘ',
        'ǘ',
        'Ǚ',
        'ǚ',
        'Ǜ',
        'ǜ',
        'Ǻ',
        'ǻ',
        'Ǽ',
        'ǽ',
        'Ǿ',
        'ǿ',
        'Ά',
        'ά',
        'Έ',
        'έ',
        'Ό',
        'ό',
        'Ώ',
        'ώ',
        'Ί',
        'ί',
        'ϊ',
        'ΐ',
        'Ύ',
        'ύ',
        'ϋ',
        'ΰ',
        'Ή',
        'ή'
    ];
    const replace = [
        'A',
        'A',
        'A',
        'A',
        'A',
        'A',
        'AE',
        'C',
        'E',
        'E',
        'E',
        'E',
        'I',
        'I',
        'I',
        'I',
        'D',
        'N',
        'O',
        'O',
        'O',
        'O',
        'O',
        'O',
        'U',
        'U',
        'U',
        'U',
        'Y',
        's',
        'a',
        'a',
        'a',
        'a',
        'a',
        'a',
        'ae',
        'c',
        'e',
        'e',
        'e',
        'e',
        'i',
        'i',
        'i',
        'i',
        'n',
        'o',
        'o',
        'o',
        'o',
        'o',
        'o',
        'u',
        'u',
        'u',
        'u',
        'y',
        'y',
        'A',
        'a',
        'A',
        'a',
        'A',
        'a',
        'C',
        'c',
        'C',
        'c',
        'C',
        'c',
        'C',
        'c',
        'D',
        'd',
        'D',
        'd',
        'E',
        'e',
        'E',
        'e',
        'E',
        'e',
        'E',
        'e',
        'E',
        'e',
        'G',
        'g',
        'G',
        'g',
        'G',
        'g',
        'G',
        'g',
        'H',
        'h',
        'H',
        'h',
        'I',
        'i',
        'I',
        'i',
        'I',
        'i',
        'I',
        'i',
        'I',
        'i',
        'IJ',
        'ij',
        'J',
        'j',
        'K',
        'k',
        'L',
        'l',
        'L',
        'l',
        'L',
        'l',
        'L',
        'l',
        'l',
        'l',
        'N',
        'n',
        'N',
        'n',
        'N',
        'n',
        'n',
        'O',
        'o',
        'O',
        'o',
        'O',
        'o',
        'OE',
        'oe',
        'R',
        'r',
        'R',
        'r',
        'R',
        'r',
        'S',
        's',
        'S',
        's',
        'S',
        's',
        'S',
        's',
        'T',
        't',
        'T',
        't',
        'T',
        't',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'W',
        'w',
        'Y',
        'y',
        'Y',
        'Z',
        'z',
        'Z',
        'z',
        'Z',
        'z',
        's',
        'f',
        'O',
        'o',
        'U',
        'u',
        'A',
        'a',
        'I',
        'i',
        'O',
        'o',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'U',
        'u',
        'A',
        'a',
        'AE',
        'ae',
        'O',
        'o',
        'Α',
        'α',
        'Ε',
        'ε',
        'Ο',
        'ο',
        'Ω',
        'ω',
        'Ι',
        'ι',
        'ι',
        'ι',
        'Υ',
        'υ',
        'υ',
        'υ',
        'Η',
        'η'
    ];
    for (let i = 0; i < find.length; i += 1) {
        name.replaceAll(find[i], replace[i]);
    }
    let newName = '';
    const accepted = /^[a-zA-Z0-9_\-\. ]$/;
    // Then strip all unwanted characters that are left.
    for (let i = 0; i < name.length; i += 1) {
        const char = name[i];
        if (accepted.test(char)) {
            newName = `${newName}${char}`;
        }
    }
    // Then replace all duplicated special characters
    while (newName.includes('  ') ||
        newName.includes('--') ||
        newName.includes('__') ||
        newName.includes('..')) {
        newName = newName
            .replaceAll('  ', ' ')
            .replaceAll('--', '-')
            .replaceAll('__', '_')
            .replaceAll('..', '.');
    }
    return newName;
};
